import styled from 'styled-components';
import { Typ51, Typ35 } from 'dc/Typ';

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 62px;
  max-width: 538px;
`;

export const Title = styled(Typ51)`
  margin-bottom: 16px;
`;

export const Text = styled(Typ35)``;
